var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 0H1.375C0.615 0 0 0.615 0 1.375V9.125C0 9.885 0.615 10.5 1.375 10.5H5.445C4.99172 9.88438 4.7481 9.13949 4.75 8.375C4.75 6.375 6.375 4.75 8.375 4.75C8.415 4.75 8.46 4.75 8.5 4.755V1.375C8.5 0.615 7.885 0 7.125 0ZM2 2H4C4.275 2 4.5 2.225 4.5 2.5C4.5 2.775 4.275 3 4 3H2C1.725 3 1.5 2.775 1.5 2.5C1.5 2.225 1.725 2 2 2ZM4.5 7H2C1.725 7 1.5 6.775 1.5 6.5C1.5 6.225 1.725 6 2 6H4.5C4.775 6 5 6.225 5 6.5C5 6.775 4.775 7 4.5 7ZM6.5 5H2C1.725 5 1.5 4.775 1.5 4.5C1.5 4.225 1.725 4 2 4H6.5C6.775 4 7 4.225 7 4.5C7 4.775 6.775 5 6.5 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 11C6.9275 11 5.75 9.8225 5.75 8.375C5.75 6.9275 6.9275 5.75 8.375 5.75C9.8225 5.75 11 6.9275 11 8.375C11 9.8225 9.8225 11 8.375 11ZM8.375 6.75C7.479 6.75 6.75 7.479 6.75 8.375C6.75 9.271 7.479 10 8.375 10C9.271 10 10 9.271 10 8.375C10 7.479 9.271 6.75 8.375 6.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 11.9999C11.4343 12 11.3692 11.9871 11.3086 11.9619C11.2479 11.9368 11.1928 11.8999 11.1464 11.8534L9.52142 10.2284C9.475 10.182 9.43818 10.1269 9.41305 10.0662C9.38793 10.0056 9.375 9.94058 9.375 9.87492C9.375 9.80927 9.38793 9.74427 9.41305 9.68361C9.43818 9.62296 9.475 9.56785 9.52142 9.52142C9.56785 9.475 9.62296 9.43818 9.68361 9.41305C9.74427 9.38793 9.80927 9.375 9.87492 9.375C9.94058 9.375 10.0056 9.38793 10.0662 9.41305C10.1269 9.43818 10.182 9.475 10.2284 9.52142L11.8534 11.1464C11.9236 11.2163 11.9714 11.3054 11.9908 11.4024C12.0102 11.4995 12.0004 11.6001 11.9625 11.6916C11.9246 11.783 11.8604 11.8611 11.7781 11.916C11.6957 11.9709 11.5989 12.0001 11.4999 11.9999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2835e621bcff2baabaecc4fc781d774a.svg";
export { ForwardRef as ReactComponent };